import { IUserServiceApis } from "./IUserServiceApis"
import ApiUtils from "../ApiUtils"

const UserServiceApiUrl = {
	findUserById: (userId: string) => `/v1/users/${userId}`,
	findUsersByIds: "/v1/users/bulkUsers",
	getUserInfo: "/v1/users/me",
}

class UserServiceApis implements IUserServiceApis {
	getServiceUrl = (url: string) => "/user-service" + url
	getUserInfo(userId: string) {
		const url = this.getServiceUrl(UserServiceApiUrl.getUserInfo)
		return ApiUtils.get(url, { userid: userId }, "")
	}
	//
	findUserByUserId(userId: number) {
		const url = this.getServiceUrl(UserServiceApiUrl.findUserById(userId.toString()))
		return ApiUtils.get(url)
	}

	findUsersByUserIds(userIds: number[]) {
		const url = this.getServiceUrl(UserServiceApiUrl.findUsersByIds)
		return ApiUtils.post(url, { userIds })
	}
}

export default UserServiceApis
